import { useEffect, useCallback } from 'react'

export const useRealViewportHeight = (debounceMs: number = 100): void => {
  const setRealViewportHeight = useCallback((): void => {
    const realHeight: number = window.visualViewport?.height ?? window.innerHeight
    document.documentElement.style.setProperty('--real-vh', `${realHeight}px`)
  }, [])

  useEffect(() => {
    let debounceTimer: NodeJS.Timeout
    
    const debouncedSetHeight = (): void => {
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(setRealViewportHeight, debounceMs)
    }

    setRealViewportHeight()

    window.addEventListener('load', setRealViewportHeight)
    window.addEventListener('resize', debouncedSetHeight)
    
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', debouncedSetHeight)
    }

    return (): void => {
      clearTimeout(debounceTimer)
      window.removeEventListener('load', setRealViewportHeight)
      window.removeEventListener('resize', debouncedSetHeight)
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', debouncedSetHeight)
      }
    }
  }, [setRealViewportHeight, debounceMs])
}